"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTableContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useTableContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useTableContextValues_unstable(state) {
    const { size, noNativeElements, sortable } = state;
    const tableContext = _react.useMemo(()=>({
            noNativeElements,
            size,
            sortable
        }), [
        noNativeElements,
        size,
        sortable
    ]);
    return {
        table: tableContext
    };
}
